// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__29aPx","title":"ClientInsurance_title__1Tqpf","itemText":"ClientInsurance_itemText__3KZ5o"};